import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaBars, FaXmark } from 'react-icons/fa6';
import logo from '../shared/assets/ng_transparent.png';

const GITHUB_URL = 'https://github.com/gardner-nick';
const LINKEDIN_URL = 'https://www.linkedin.com/in/nicholas-gardner-7b588a105/';

// Every nav item is a real router link. In-page section links (`/#about`)
// resolve to home-page sections; `HomePage`'s `useScrollToHash` scrolls to the
// target so they work from any route without a full page reload.
type NavItem = { label: string; to: string };

const NAV: NavItem[] = [
  { label: 'about', to: '/#about' },
  { label: 'stack', to: '/#skills' },
  // { label: 'experience', to: '/#experience' },
  { label: 'projects', to: '/#projects' },
  { label: 'blog', to: '/blog' },
];

export function Taskbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-border bg-bg/80 backdrop-blur">
      <nav className="mx-auto flex max-w-content items-center justify-between px-5 py-3">
        <Link to="/" className="flex items-center gap-2" aria-label="Home">
          <img src={logo} alt="" className="h-8 w-8" />
          <span className="font-mono text-sm text-muted">~/nick-gardner</span>
        </Link>

        <div className="hidden items-center gap-6 md:flex">
          {NAV.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="font-mono text-sm text-muted transition-colors hover:text-accent"
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-1">
          <a
            href={GITHUB_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
            className="flex h-9 w-9 items-center justify-center rounded-md text-muted transition-colors hover:bg-elevated hover:text-accent"
          >
            <FaGithub />
          </a>
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            className="flex h-9 w-9 items-center justify-center rounded-md text-muted transition-colors hover:bg-elevated hover:text-accent"
          >
            <FaLinkedin />
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            aria-controls="mobile-nav"
            className="flex h-9 w-9 items-center justify-center rounded-md text-muted transition-colors hover:bg-elevated hover:text-accent md:hidden"
          >
            {open ? <FaXmark /> : <FaBars />}
          </button>
        </div>
      </nav>

      {/* Mobile dropdown nav */}
      {open && (
        <div id="mobile-nav" className="border-t border-border bg-bg/95 md:hidden">
          <div className="mx-auto flex max-w-content flex-col px-5 py-2">
            {NAV.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                onClick={() => setOpen(false)}
                className="rounded-md px-2 py-3 font-mono text-sm text-muted transition-colors hover:bg-elevated hover:text-accent"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
